import { render, staticRenderFns } from "./AttachGpu.vue?vue&type=template&id=6d350cac&"
import script from "./AttachGpu.vue?vue&type=script&lang=js&"
export * from "./AttachGpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports